var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/thumbs_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-144.000000, -447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-4",
    transform: "translate(48.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Thumbs-Down",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,5.18750002 L2,14.5625 C2,15.0802735 2.41972545,15.5 2.93749751,15.5 L6.0624892,15.5 C6.58026126,15.5 6.9999867,15.0802735 6.9999867,14.5625 L6.9999867,5.18750002 C6.9999867,4.66972658 6.58026126,4.25000002 6.0624892,4.25000002 L2.93749751,4.25000002 C2.41972545,4.25000002 2,4.66972658 2,5.18750002 Z M3.56249585,13 C3.56249585,12.4822266 3.98222129,12.0625 4.49999335,12.0625 C5.01776541,12.0625 5.43749086,12.4822266 5.43749086,13 C5.43749086,13.5177735 5.01776541,13.9375 4.49999335,13.9375 C3.98222129,13.9375 3.56249585,13.5177735 3.56249585,13 Z M14.1874676,23 C13.3990713,23 13.0357128,21.4651172 12.8620414,20.7423828 C12.6586826,19.8960547 12.4484097,19.0208985 11.87013,18.4415235 C10.6018131,17.1710547 9.93642421,15.5521875 8.38900645,14.023125 L8.38900643,14.023125 C8.30006252,13.9352039 8.25002242,13.8153383 8.25002242,13.6902734 L8.25002242,5.33988281 C8.25002242,5.084375 8.45482656,4.87589844 8.71029463,4.87121094 C9.32869143,4.85988281 10.1436502,4.5165625 10.7669689,4.23925781 C12.0073562,3.68742188 13.5511021,3.00066406 15.4372689,3 L15.5483624,3 C17.2193345,3 19.1953449,3.01613281 19.9926474,4.16160156 C20.3204591,4.63257813 20.4006932,5.21761719 20.2328031,5.90503906 C20.8699889,6.57117187 21.2118239,7.81375 20.8727232,8.82523438 C21.5580339,9.74054687 21.6204947,11.0178906 21.236316,11.9294922 L21.2406129,11.9337891 C21.705182,12.4005469 22.003228,13.1548437 21.9999736,13.8555469 C21.9938531,15.0411719 20.9781917,16.125 19.6736639,16.125 L15.7000807,16.125 C15.9855097,17.2320312 16.9999601,18.1614062 16.9999601,19.8182812 C16.9999601,22.6875 15.1249651,23 14.1874676,23 L14.1874676,23 Z",
    id: "Icon",
    fill: "#586179"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs_down.b95076f6.svg";
export { ForwardRef as ReactComponent };